module.exports = __webpack_public_path__ + "img/locations_layout1.aa4911c6.png";